import { useAchievementTypes, useReduxState } from 'hooks';
import { AchievementIcon } from 'components/achievements';
import {
  ContentLabel,
  ContentValue,
  DisplayFormattedDate,
  EmptyIndicator,
  FlexContainer,
  TitleWithIcon,
  User
} from 'components/common';
import { Box, BoxBackLink } from 'components/common/box';

import type { GetAchievementDiscussionAnalysisRes } from 'shared-types/responses';

interface Props {
  data: GetAchievementDiscussionAnalysisRes | null;
}

const ConversationAnalysisInfo = ({ data }: Props) => {
  const { messages } = useReduxState();

  const achievementTypes = useAchievementTypes();

  return (
    <div className="info">
      <Box
        title={
          <BoxBackLink
            as="/achievements/conversation-analyses"
            href="/achievements/conversation-analyses"
            text={messages.achievementConversationAnalyses}
          />
        }
      >
        {data ? (
          <div>
            <FlexContainer style={{ gap: 15, minWidth: 250 }}>
              <AchievementIcon size="small" type={data.achievement?.type} />

              <TitleWithIcon
                title={data.achievement?.title}
                titleLink={{
                  href: `/admin/achievements/${data.achievement?.id}`
                }}
              >
                {achievementTypes[data.achievement?.type]?.title}
              </TitleWithIcon>
            </FlexContainer>

            <ContentLabel horizontal={true} label={messages.commonCreatedBy}>
              <ContentValue>
                {data.user ? <User user={data.user} /> : null}
              </ContentValue>
            </ContentLabel>

            <ContentLabel horizontal={true} label={messages.excelDate}>
              <ContentValue>
                <DisplayFormattedDate date={data.createdAt} />
              </ContentValue>
            </ContentLabel>
          </div>
        ) : (
          <EmptyIndicator
            icon="wand-magic-sparkles"
            title={messages.achievementConversationAnalysesNotFound}
          />
        )}
      </Box>

      <style jsx>{`
        .info {
          display: flex;
          flex-direction: column;
          gap: 30px;
        }
      `}</style>
    </div>
  );
};

export default ConversationAnalysisInfo;
